import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { N800, N30 } from '@atlaskit/theme/colors';

import { StickyBanner } from '@confluence/content-header';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledContent = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'&.sticky-header': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'#title-text': {
			color: `${token('color.text', N800)}`,
			fontSize: 20,
			lineHeight: '24px',
			padding: `${token('space.200', '16px')} 0px`,
			alignItems: 'center',
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'&.stuck-state-top': {
			boxShadow: token('elevation.shadow.overflow', `0px 2px 0px ${N30}`),
		},
		height: 56,
		paddingRight: token('space.200', '16px'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	"[data-test-id='header-animated-box']": {
		width: '100%',
		left: 0,
	},
});

export const StickyHeaderContainer: React.FC<{
	children?: React.ReactNode;
}> = ({ children }) => (
	<StyledContainer>
		<StickyBanner>
			<StyledContent id="content-header-container" data-testid="sticky-header-content">
				{children}
			</StyledContent>
		</StickyBanner>
	</StyledContainer>
);
